export async function fetchAPI<T>(key: string): Promise<T> {
  const response = await fetch(key)
  const responseBody = await response.json()

  return responseBody as T
}

type TokenReq = {
  token?: string | null
}

export async function getAPI<ResType>(key: string, token: string | null): Promise<ResType> {
  try {
    const response = await fetch(key, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'X-Csrf-Protection': '1',
        Authorization: token ? `Bearer ${token}` : '',
      },
    })

    if (!response.ok) {
      const errorBody = await response.json()
      throw new Error(errorBody.message || 'Something went wrong')
    }

    const responseBody = await response.json()

    return responseBody as ResType
  } catch (error) {
    throw new Error(error instanceof Error ? error.message : String(error))
  }
}

export async function postAPI<ReqType, ResType>(
  key: string,
  { arg: { token, ...arg } }: { arg: ReqType & TokenReq },
): Promise<ResType> {
  try {
    const response = await fetch(key, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Csrf-Protection': '1',
        Authorization: token ? `Bearer ${token}` : '',
      },
      body: JSON.stringify(arg),
    })

    if (!response.ok) {
      const errorBody = await response.json()
      throw new Error(errorBody.message || 'Something went wrong')
    }

    const responseBody = await response.json()

    return responseBody as ResType
  } catch (error) {
    throw new Error(error instanceof Error ? error.message : String(error))
  }
}

export async function patchAPI<ReqType, ResType>(
  key: string,
  { arg: { token, ...arg } }: { arg: ReqType & TokenReq },
): Promise<ResType> {
  try {
    const response = await fetch(key, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        'X-Csrf-Protection': '1',
        Authorization: token ? `Bearer ${token}` : '',
      },
      body: JSON.stringify(arg),
    })

    if (!response.ok) {
      const errorBody = await response.json()
      throw new Error(errorBody.message || 'Something went wrong')
    }

    const responseBody = await response.json()

    return responseBody as ResType
  } catch (error) {
    throw new Error(error instanceof Error ? error.message : String(error))
  }
}
